import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation updateUserRole($id: String!, $data: updateUserInput!) {
    updateUserRole(id: $id, data: $data) {
      id
      status
      error {
        message
        statusCode
      }
    }
  }
`;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const updateUserRoleRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {id: String;data: TYPES.UpdateUserInput;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'user/update_user_role',
  async (
  params: {id: String;data: TYPES.UpdateUserInput;},
  { extra: client }) =>
  {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.updateUserRole;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const updateUserRoleSlice = createSlice({
  name: 'update_user_role',
  initialState: initialState,
  reducers: {
    updateUserRoleClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(updateUserRoleRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(updateUserRoleRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(updateUserRoleRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { updateUserRoleClear } = updateUserRoleSlice.actions;

export const updateUserRole = createSelector(
  (state: RootState) => state.user.updateUserRole.result,
  (state: RootState) => state.user.updateUserRole.error,
  (state: RootState) => state.user.updateUserRole.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default updateUserRoleSlice.reducer;